import { Link } from 'icon'

import BaseBtn from './BaseBtn'

const FileBtn = (props) => {
  const { disabled, onClick, loading, tag } = props

  return (
    <BaseBtn
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      tag={tag}
      icon={<Link color="white" size={0.6} />}
      color={'white'}
      bg_color={'#626262'}
      border_color={'#626262'}
    />
  )
}

export default FileBtn
